// src/js/gsap.js
gsap.registerPlugin(ScrollTrigger, Flip, DrawSVGPlugin, SplitText, ScrollToPlugin, MorphSVGPlugin);
gsap.config({ force3D: true });
gsap.defaults({ lazy: false });

let flipCtx;
// horizontalCtx removed in v3 — horizontal scroll przeniesiony do Swipera (swiper-engine.js)
let scrubSwitchTimer;

/* =========================
   BLOB MORPH (turquoise + white)
========================= */
function initBlobMorph() {
  const turqPath = document.querySelector('.blob_turquoise > path');
  const whitePath = document.querySelector('.blob_white > path');
  if (!turqPath || !whitePath) return;

  const turqTargets = ['#blob_turq_egg', '#blob_turq_amorph', '#blob_turq_rect'];
  const whiteTargets = ['#blob_white_egg', '#blob_white_amorph', '#blob_white_rect'];

  const turqTl = gsap.timeline({ repeat: -1, defaults: { ease: 'sine.inOut', duration: 12 } });
  turqTargets.forEach((t) => turqTl.to(turqPath, { morphSVG: t }));
  turqTl.to(turqPath, { morphSVG: '#blob_turq_rect' });

  const whiteTl = gsap.timeline({ repeat: -1, defaults: { ease: 'sine.inOut', duration: 14 } });
  whiteTargets.forEach((t) => whiteTl.to(whitePath, { morphSVG: t }));
  whiteTl.to(whitePath, { morphSVG: '#blob_white_rect' });
}

document.addEventListener('DOMContentLoaded', initBlobMorph);

/* =========================
   FLIP SECTION
========================= */

function createTweenFlip() {
  const starterElement = document.querySelector('#starter');
  const starterWrapperBg = document.querySelector('.starter__wrap--bg');
  const horizontal__blob = document.querySelector('.horizontal__blob');
  if (!starterElement) return;

  const starterItems = starterElement.querySelectorAll('.starter__item');

  flipCtx && flipCtx.revert();
  starterElement.classList.remove('starter--final');

  const videos = starterElement.querySelectorAll('.starter__item:not(:nth-child(3)) video');
  const videosAll = starterElement.querySelectorAll('.starter__item video');

  gsap.set(videos, { scale: 1.5 });

  flipCtx = gsap.context(() => {
    starterElement.classList.add('starter--final');
    const flipState = Flip.getState(starterItems);
    starterElement.classList.remove('starter--final');

    const flip = Flip.to(flipState, {
      simple: true,
      ease: 'expoScale(1, 5)',
      duration: 8,
    });

    let starterFinishedDispatched = false;
    const dispatchStarterFinished = () => {
      if (starterFinishedDispatched) return;
      starterFinishedDispatched = true;
      // Po zaniknięciu startera podnosimy .horizontal nad starter (z-index)
      // i jawnie chowamy starter — pin tworzy stacking context który mógł
      // trzymać .starter__wrap nad .horizontal mimo wyższego z-indexu.
      const h = document.querySelector('.horizontal');
      if (h) h.classList.add('is-active');
      const starterWrap = document.querySelector('.starter__wrap');
      if (starterWrap) starterWrap.classList.add('is-hidden');
      document.dispatchEvent(new CustomEvent('starter:finished'));
    };

    // Odwrotność dispatchStarterFinished — wywoływana gdy user scrolluje w górę
    // do pin zone (ScrollTrigger onEnterBack). Pozwala "wrócić" do startera.
    const undoStarterFinished = () => {
      if (!starterFinishedDispatched) return;
      starterFinishedDispatched = false;
      const h = document.querySelector('.horizontal');
      if (h) h.classList.remove('is-active');
      const starterWrap = document.querySelector('.starter__wrap');
      if (starterWrap) starterWrap.classList.remove('is-hidden');
      // Cofnij concept entry żeby przy ponownym wjechaniu nie był nadal w stanie końcowym.
      if (typeof window.__reverseConceptEntry === 'function') {
        window.__reverseConceptEntry();
      }
      document.dispatchEvent(new CustomEvent('starter:reverted'));
    };

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: starterElement,
        start: 'center center',
        end: '+=300%',
        scrub: true,
        pin: starterElement.parentNode,
        pinSpacing: true,
        invalidateOnRefresh: true,
        onLeave: dispatchStarterFinished,
        onEnterBack: undoStarterFinished,
        onUpdate: (self) => {
          // Histereza: dispatch gdy progress > 0.95, undo gdy < 0.9.
          // Bez tego onUpdate i onEnterBack walczyły o flagę.
          if (self.progress >= 0.95) dispatchStarterFinished();
          else if (self.progress < 0.9) undoStarterFinished();
        },
      },
    });

    window.__flipTimeline = tl;

    // Safari fix: play starter videos directly (IntersectionObserver unreliable in pinned sections)
    starterElement.querySelectorAll('video').forEach((v) => {
      v.play().catch(() => {});
    });

    tl.add(flip, 0);

    tl.to(
      videos,
      {
        scale: 1,
        ease: 'expoScale(1, 5)',
        duration: 6,
      },
      0,
    );

    videosAll.forEach((video, index) => {
      const groupIndex = Math.floor(index / 2);
      const isSecond = index % 2 === 1;

      const pos = isSecond ? `${groupIndex * 2}` : `${groupIndex * 2.5}`;

      tl.to(
        video,
        {
          delay: 8,
          autoAlpha: 0,
          duration: 2,
        },
        pos,
      );
    });

    // Reveal concept earlier: fade out entire starter element + bg + reveal blob
    // synced with 3rd-from-last video fadeout (so concept underneath shows through)
    const thirdFromLastIdx = Math.max(0, videosAll.length - 3);
    const tflGroup = Math.floor(thirdFromLastIdx / 2);
    const tflIsSecond = thirdFromLastIdx % 2 === 1;
    const tflPos = (tflIsSecond ? tflGroup * 2 : tflGroup * 2.5) + 8; // +8 delay

    tl.to(starterElement, { autoAlpha: 0, duration: 2.5, ease: 'power2.inOut' }, tflPos);
    tl.to(
      starterWrapperBg,
      { autoAlpha: 0, scaleY: 0, ease: 'expoScale(1, 5)', duration: 2 },
      tflPos,
    );
    tl.to(
      horizontal__blob,
      { autoAlpha: 0.2, scale: 1, ease: 'expoScale(1, 2.5)', duration: 4 },
      tflPos,
    );

    // Concept reveal — po zakończeniu ruchu logo do headera (logo kończy na 19,
    // pointer-events 'auto' przy 19; concept startuje przy 21).
    tl.call(
      () => {
        if (typeof window.__playConceptEntry === 'function') {
          window.__playConceptEntry();
        }
      },
      null,
      21,
    );

    // Logo: idle fade + scroll-driven move to header
    const logo = document.querySelector('.site-header__logo');
    if (logo) {
      let idleTimer = null;
      let isFaded = false;
      let lastX = 0;
      let lastY = 0;
      let lastMoveTime = 0;

      function fadeOut() {
        if (!isFaded) {
          isFaded = true;
          gsap.to(logo, { opacity: 0.1, duration: 1.5, ease: 'power2.inOut' });
        }
      }

      function fadeIn() {
        if (isFaded) {
          isFaded = false;
          gsap.to(logo, { opacity: 1, duration: 0.4, ease: 'power2.out' });
        }
      }

      function startIdleTimer() {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(fadeOut, 1500);
      }

      function onMouseMove(e) {
        const now = Date.now();
        if (now - lastMoveTime < 50) return;
        lastMoveTime = now;

        const dx = Math.abs(e.clientX - lastX);
        const dy = Math.abs(e.clientY - lastY);

        if (dx > 10 || dy > 10) {
          lastX = e.clientX;
          lastY = e.clientY;
          fadeIn();
          startIdleTimer();
        }
      }

      function onScroll() {
        fadeIn();
        startIdleTimer();
      }

      function enableIdleTracking() {
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('scroll', onScroll);
        startIdleTimer();
      }

      function disableIdleTracking() {
        clearTimeout(idleTimer);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('scroll', onScroll);
        // Ensure logo is fully visible when idle tracking stops
        gsap.killTweensOf(logo, 'opacity');
        gsap.set(logo, { opacity: 1 });
        isFaded = false;
      }

      // Start idle tracking immediately
      enableIdleTracking();

      // Logo moves to header, synced with menu reveal
      const siteHeader = document.querySelector('.site-header');
      tl.to(
        logo,
        {
          y: 0,
          scale: 1,
          opacity: 1,
          ease: 'power2.inOut',
          duration: 5,
          onStart: () => {
            disableIdleTracking();
          },
          onComplete: () => {
            siteHeader && siteHeader.classList.add('header--menu-visible');
          },
          onReverseComplete: () => {
            siteHeader && siteHeader.classList.remove('header--menu-visible');
            enableIdleTracking();
          },
        },
        14,
      );

      // Enable pointer events after logo lands
      tl.set(logo, { pointerEvents: 'auto' }, 19);
    }

    // Menu items + socials reveal (synced with 2nd set of videos fading out)
    const navLeft = document.querySelector('.site-header__nav--left');
    const navRight = document.querySelector('.site-header__nav--right');
    const socialNav = document.querySelector('.site-social');

    const leftItems = navLeft ? navLeft.querySelectorAll('li') : [];
    const rightItems = navRight ? navRight.querySelectorAll('li') : [];

    if (navLeft && leftItems.length) {
      tl.to(navLeft, { opacity: 1, duration: 0.01 }, 14);
      tl.fromTo(
        leftItems,
        { opacity: 0, x: -30 },
        { opacity: 1, x: 0, duration: 2, stagger: 0.25, ease: 'power2.out' },
        14,
      );
    }

    if (navRight && rightItems.length) {
      tl.to(navRight, { opacity: 1, duration: 0.01 }, 14);
      tl.fromTo(
        rightItems,
        { opacity: 0, x: 30 },
        { opacity: 1, x: 0, duration: 2, stagger: 0.25, ease: 'power2.out' },
        14,
      );
    }

    if (socialNav) {
      tl.to(socialNav, { opacity: 1, duration: 2, ease: 'power2.out' }, 15);
    }
  }, starterElement);
}

/* =========================
   PORTFOLIO: Flip Modal + Filtering
========================= */

function initPortfolio() {
  const modal = document.querySelector('.portfolio__modal');
  if (!modal) return;

  const modalContent = modal.querySelector('.portfolio__modal-content');
  const modalOverlay = modal.querySelector('.portfolio__modal-overlay');
  const modalTitle = modal.querySelector('.portfolio__modal-title');
  const modalDesc = modal.querySelector('.portfolio__modal-desc');
  const modalFooter = modal.querySelector('.portfolio__modal-footer');
  const items = gsap.utils.toArray('.portfolio__item');
  const itemContents = gsap.utils.toArray('.portfolio__item-content');
  let activeIndex;

  // FORCE: Clear any inline display styles on init (all items visible by default)
  items.forEach((item) => {
    item.style.display = '';

    // Video hover play/pause (always muted in grid)
    const video = item.querySelector('video');
    if (video) {
      item.addEventListener('mouseenter', () => {
        video.muted = true;
        video.play();
      });
      item.addEventListener('mouseleave', () => {
        video.pause();
      });
    }
  });

  function openModal(content, i) {
    const doOpen = () => {
      const state = Flip.getState(content);
      modalContent.appendChild(content);
      activeIndex = i;

      modalTitle.textContent = content.dataset.title;
      modalDesc.innerHTML = content.dataset.desc;

      document.body.classList.add('portfolio-modal-open');
      document.body.style.overflow = 'hidden';
      gsap.set(modal, { autoAlpha: 1, pointerEvents: 'all', zIndex: 2000 });

      Flip.from(state, { duration: 0.7, ease: 'power1.inOut' });
      gsap.to(modalOverlay, { autoAlpha: 1, duration: 0.35 });
      gsap.to(modalFooter, { autoAlpha: 1, duration: 0.4, delay: 0.3 });

      // Play video in modal — lazy load full quality src
      const video = content.querySelector('video');
      const playBtn = content.querySelector('.portfolio__play-btn');
      if (video) {
        video.style.display = 'block';
        video.muted = true;
        video.setAttribute('controls', '');

        const fullSrc = video.dataset.fullSrc;
        const source = video.querySelector('source');
        const needsLoad = fullSrc && source && source.src !== fullSrc;

        const doPlay = () => {
          video.play().catch(() => {
            if (playBtn) playBtn.classList.add('is-visible');
          });
          if (playBtn) playBtn.classList.remove('is-visible');
        };

        if (needsLoad) {
          source.src = fullSrc;
        }

        if (needsLoad || video.readyState < 3) {
          video.load();
          video.addEventListener('canplay', doPlay, { once: true });
          setTimeout(function () {
            if (video.paused) doPlay();
          }, 1500);
        } else {
          doPlay();
        }

        video.onpause = () => {
          if (playBtn) playBtn.classList.add('is-visible');
          video.removeAttribute('controls');
        };
        video.onplay = () => {
          if (playBtn) playBtn.classList.remove('is-visible');
          video.setAttribute('controls', '');
        };
      }
    };

    // Na mobile: scroll do sekcji portfolio jeśli jest ucięta
    if (window.innerWidth < 1024) {
      const portfolioSection = document.querySelector('.portfolio');
      if (portfolioSection) {
        const rect = portfolioSection.getBoundingClientRect();
        if (rect.top < -5 || rect.top > 20) {
          window.scrollTo({ top: window.scrollY + rect.top, behavior: 'smooth' });
          setTimeout(doOpen, 400);
          return;
        }
      }
    }

    doOpen();
  }

  function closeModal() {
    if (activeIndex === undefined) return;

    const content = itemContents[activeIndex];
    const item = items[activeIndex];
    const closingIndex = activeIndex;
    activeIndex = undefined;

    // Zmierz aktualne wymiary contentu w modalu i docelowe w kafelku
    const contentRect = content.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    // Ustaw content na fixed z aktualną pozycją (startowy stan)
    gsap.set(content, {
      position: 'fixed',
      top: contentRect.top,
      left: contentRect.left,
      width: contentRect.width,
      height: contentRect.height,
      zIndex: 9999,
    });

    // Tytuł i opis rozsuwają się z fade outem
    gsap.to(modalTitle, { x: -60, autoAlpha: 0, duration: 0.4, ease: 'power2.in' });
    gsap.to(modalDesc, { x: 60, autoAlpha: 0, duration: 0.4, ease: 'power2.in' });
    gsap.to(modalOverlay, { autoAlpha: 0, duration: 0.5, ease: 'power1.inOut' });
    gsap.set(modal, { pointerEvents: 'none' });

    // Animuj z pozycji modala do pozycji kafelka
    gsap.to(content, {
      width: itemRect.width,
      height: itemRect.height,
      top: itemRect.top,
      left: itemRect.left,
      borderRadius: '1rem',
      duration: 0.7,
      ease: 'power1.inOut',
      onComplete: () => {
        // Po animacji: wróć content do kafelka i wyczyść inline styles
        item.appendChild(content);
        gsap.set(content, { clearProps: 'all' });
        gsap.set(modal, { autoAlpha: 0, zIndex: -1 });
        gsap.set(modalFooter, { autoAlpha: 0 });
        gsap.set([modalTitle, modalDesc], { clearProps: 'x,opacity,visibility' });
        document.body.classList.remove('portfolio-modal-open');
        document.body.style.overflow = '';
      },
    });

    // Pause video when closing modal
    const video = content.querySelector('video');
    const playBtn = content.querySelector('.portfolio__play-btn');
    if (video) {
      video.onpause = null;
      video.onplay = null;
      video.pause();
      video.currentTime = 0;
      video.removeAttribute('controls');
      video.style.display = '';
      video.muted = true;
    }
    if (playBtn) playBtn.classList.remove('is-visible');
  }

  itemContents.forEach((content, i) => {
    content.addEventListener('click', (e) => {
      if (e.target.closest('.portfolio__play-btn')) return;
      if (activeIndex !== undefined) {
        // W modalu — klik na video lub kontrolki nie zamyka
        if (e.target.closest('video')) return;
        closeModal();
      } else {
        openModal(content, i);
      }
    });
  });

  // Play button click in grid opens modal
  items.forEach((item, i) => {
    const playBtn = item.querySelector('.portfolio__play-btn');
    if (playBtn) {
      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (activeIndex !== undefined) return;
        openModal(itemContents[i], i);
      });
    }
  });

  // Play button click — toggle play/pause in modal
  itemContents.forEach((content) => {
    const playBtn = content.querySelector('.portfolio__play-btn');
    const video = content.querySelector('video');
    if (playBtn && video) {
      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (activeIndex === undefined) return;
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  });

  modal.querySelector('.portfolio__modal-close')?.addEventListener('click', closeModal);
  modalOverlay?.addEventListener('click', closeModal);

  // Mobile: swipe down zamyka modal
  let touchStartY = 0;
  modal.addEventListener(
    'touchstart',
    (e) => {
      touchStartY = e.touches[0].clientY;
    },
    { passive: true },
  );
  modal.addEventListener(
    'touchend',
    (e) => {
      if (activeIndex === undefined) return;
      const delta = e.changedTouches[0].clientY - touchStartY;
      if (delta > 60) closeModal();
    },
    { passive: true },
  );

  // === Flip Filtering (radio buttons) ===
  // Mobile i desktop mają osobne name= (różne IDki żeby uniknąć kolizji).
  const radios = gsap.utils.toArray(
    'input[name="portfolio-filter"], input[name="portfolio-filter-mobile"]',
  );

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      const value = radio.value;
      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Mobile: prosty fade bez Flip (Flip psuje 2-kolumnowy grid)
        items.forEach((item) => {
          const show = value === 'all' || item.classList.contains(value);
          if (show) {
            item.style.display = 'inline-flex';
            gsap.fromTo(
              item,
              { opacity: 0, scale: 0.9 },
              { opacity: 1, scale: 1, duration: 0.35, ease: 'power2.out' },
            );
          } else {
            gsap.to(item, {
              opacity: 0,
              scale: 0.9,
              duration: 0.25,
              ease: 'power2.in',
              onComplete: () => {
                item.style.display = 'none';
              },
            });
          }
        });
      } else {
        // Desktop: Flip animation
        const state = Flip.getState(items);

        items.forEach((item) => {
          if (value === 'all') {
            item.style.display = 'inline-flex';
          } else {
            const match = item.classList.contains(value);
            item.style.display = match ? 'inline-flex' : 'none';
          }
        });

        Flip.from(state, {
          duration: 0.7,
          scale: true,
          ease: 'power1.inOut',
          stagger: 0.08,
          absolute: true,
          onEnter: (els) =>
            gsap.fromTo(els, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, duration: 1 }),
          onLeave: (els) => gsap.to(els, { opacity: 0, scale: 0, duration: 1 }),
        });
      }
    });
  });
}

/* =========================
   SOCIAL DOCK HOVER (macOS-style)
========================= */

function initSocialDock() {
  const nav = document.querySelector('.site-social');
  if (!nav) return;

  const items = nav.querySelectorAll('li');
  if (!items.length) return;

  function onEnter(e) {
    const hovered = e.currentTarget;
    const idx = Array.from(items).indexOf(hovered);

    items.forEach((item, i) => {
      const dist = Math.abs(i - idx);

      if (dist === 0) {
        gsap.to(item, { scale: 1.4, y: -6, duration: 0.3, ease: 'back.out(1.7)' });
      } else if (dist === 1) {
        gsap.to(item, { scale: 1, y: 0, x: i < idx ? -4 : 4, duration: 0.3, ease: 'power2.out' });
      } else {
        gsap.to(item, { scale: 1, y: 0, x: 0, duration: 0.3, ease: 'power2.out' });
      }
    });
  }

  function onLeaveNav() {
    items.forEach((item) => {
      gsap.to(item, { scale: 1, y: 0, x: 0, duration: 0.4, ease: 'power2.out' });
    });
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', onEnter);
  });

  nav.addEventListener('mouseleave', onLeaveNav);
}

/* =========================
   ANCHOR SCROLL
========================= */

function initAnchorScrolling() {
  // v3: mapping hash → Swiper slide index (desktop). Mobile uses fallback scrollIntoView.
  const panelIndexes = {
    concept: 0,
    oferta: 1,
    portfolio: 2,
    trust: 3,
    'o-nas': 4,
    nagrody: 5,
    kontakt: 6,
  };

  function scrollToHash(hash) {
    const id = hash.replace('#', '');

    // Desktop: użyj outer Swipera jeśli już zamountowany
    const sw = window.__horizontalSwiper;
    if (sw && id in panelIndexes) {
      const targetIndex = panelIndexes[id];
      // Wymuś starter Flip do końca jeśli jeszcze w pin zone
      const flipTl = window.__flipTimeline;
      if (flipTl && flipTl.scrollTrigger) {
        const fst = flipTl.scrollTrigger;
        if (window.scrollY < fst.end) {
          flipTl.progress(1, true);
          // Scroll past starter pin
          window.scrollTo(0, fst.end + 1);
        }
      }
      sw.slideTo(targetIndex);
      return;
    }

    // Mobile: wymuś mobile flip + skocz za jego pin
    const mobileFlipTl = window.__mobileFlipTimeline;
    if (mobileFlipTl && mobileFlipTl.scrollTrigger) {
      const target = document.getElementById(id);
      if (target) {
        const st = mobileFlipTl.scrollTrigger;
        if (window.scrollY < st.end) {
          mobileFlipTl.progress(1, true);
          ScrollTrigger.refresh();
        }
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const scrollPos = Math.max(targetTop, st.end);
        gsap.to(window, {
          scrollTo: { y: scrollPos, autoKill: false },
          duration: 1.2,
          ease: 'power2.inOut',
        });
        return;
      }
    }

    // Fallback
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function jumpToHash(hash) {
    const id = hash.replace('#', '');

    // Wymuś flip do końca przed skokiem (Flip i mobile)
    const flipTl = window.__flipTimeline || window.__mobileFlipTimeline;
    if (flipTl) {
      flipTl.progress(1, true);
    }

    // v3 desktop: Swiper instant jump (po starter:finished mountuje się
    // i podejmuje hash dispatched z header.php __pendingHash)
    const sw = window.__horizontalSwiper;
    if (sw && id in panelIndexes) {
      // Najpierw wymuś scroll za starter pin żeby Swiper zaczął obowiązywać
      if (flipTl && flipTl.scrollTrigger) {
        const fst = flipTl.scrollTrigger;
        if (window.scrollY < fst.end) {
          window.scrollTo(0, fst.end + 1);
        }
      }
      sw.slideTo(panelIndexes[id], 0);
      return;
    }
    // Jeśli Swiper jeszcze nie zamountowany (np. wejście z hash na świeżej stronie),
    // zapisz docelowy hash do queue i obsłuż go po starter:finished
    if (id in panelIndexes && !sw) {
      document.addEventListener('starter:finished', () => {
        const swLater = window.__horizontalSwiper;
        if (swLater) {
          setTimeout(() => swLater.slideTo(panelIndexes[id], 0), 50);
        }
      }, { once: true });
      // Wymuś scroll do końca startera
      if (flipTl && flipTl.scrollTrigger) {
        const fst = flipTl.scrollTrigger;
        window.scrollTo(0, fst.end + 1);
      }
      return;
    }

    // Mobile: panele w normalnym flow, ale starter jest pinowany (end: +=300%).
    // scrollIntoView nie może być użyte — skacze do elementu ignorując pin offset.
    // Wymuś starter do końca pinu i użyj scrollTo przez GSAP.
    const mobileFlipTl = window.__mobileFlipTimeline;
    if (mobileFlipTl && mobileFlipTl.scrollTrigger) {
      ScrollTrigger.refresh();
      const target = document.getElementById(id);
      if (target) {
        const st = mobileFlipTl.scrollTrigger;
        // Pozycja elementu w dokumencie po rozwiązaniu pinu
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        // Musi być co najmniej za końcem pinu startera
        const scrollPos = Math.max(targetTop, st.end);
        gsap.to(window, {
          scrollTo: { y: scrollPos, autoKill: false },
          duration: 0,
          onComplete: () => ScrollTrigger.update(),
        });
        return;
      }
    }

    // Fallback — brak pinnowanych sekcji
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ block: 'start' });
    }
  }

  // Interceptuj kliknięcia na wszystkie linki z # na tej samej stronie
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // Obsłuż zarówno "#hash" jak i "/#hash" (WordPress menu)
    let hash = null;
    if (href.startsWith('#') && href.length > 1) {
      hash = href;
    } else if (href.match(/^\/?#.+/)) {
      hash = '#' + href.split('#')[1];
    }
    if (!hash) return;

    e.preventDefault();

    const mobileMenu = document.getElementById('mobileMenu');
    if (mobileMenu && mobileMenu.classList.contains('is-open')) {
      setTimeout(() => scrollToHash(hash), 400);
    } else {
      scrollToHash(hash);
    }
  });

  // Obsłuż hash w URL przy załadowaniu strony
  // window.__pendingHash jest ustawiony przez inline script w header.php
  // (scroll zresetowany do 0 jeszcze przed DOMContentLoaded)
  const pageHash = window.__pendingHash || '';
  if (pageHash) {
    window.__pendingHash = '';
    // rAF żeby przeglądarka zdążyła wyrenderować układ przed skokiem
    requestAnimationFrame(() => jumpToHash(pageHash));
  }
}

/* =========================
   INIT
========================= */

document.addEventListener('DOMContentLoaded', () => {
  initSocialDock();
  initPortfolio();

  // v3: Swiper engine zamiast GSAP horizontal — inicjalizacja po starter:finished
  if (typeof initHorizontalSwiper === 'function') {
    initHorizontalSwiper();
  }

  const mm = gsap.matchMedia();

  // Desktop (>= 1024px): pełne animacje GSAP (starter Flip)
  mm.add('(min-width: 1024px)', () => {
    createTweenFlip();

    return () => {
      flipCtx && flipCtx.revert();
    };
  });

  // Mobile + tablet (< 1024px)
  mm.add('(max-width: 1023px)', () => {
    if (typeof Swiper !== 'undefined' && document.querySelector('.offer__swiper')) {
      function loadSwiperSlideVideo(slide) {
        const source = slide.querySelector('source[data-src]');
        if (source && !source.src) {
          source.src = source.dataset.src;
          const video = source.parentElement;
          video.load();
          video.play().catch(() => {});
        }
      }

      const offerSwiper = new Swiper('.offer__swiper', {
        loop: true,
        speed: 750,
        grabCursor: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        pagination: { el: '.offer__swiper .swiper-pagination', clickable: true },
        on: {
          afterInit(swiper) {
            loadSwiperSlideVideo(swiper.slides[swiper.activeIndex]);
          },
          slideChange(swiper) {
            loadSwiperSlideVideo(swiper.slides[swiper.activeIndex]);
          },
        },
      });
    }

    // Mobile starter: statyczny bento grid w stanie finalnym od razu
    const starterEl = document.querySelector('#starter');
    if (!starterEl) return;

    starterEl.classList.add('starter--mobile-final');
    window.__mobileFlipTimeline = null;

    // Odtwórz wideo — na mobile podmień src na vid_mobile jeśli dostępny
    starterEl.querySelectorAll('video').forEach((v) => {
      const source = v.querySelector('source[data-src-mobile]');
      if (source && source.dataset.srcMobile && source.dataset.srcMobile !== source.src) {
        source.src = source.dataset.srcMobile;
        v.load();
      }
      v.play().catch(() => {});
    });

    // Logo: scroll-driven z centrum do headera (bez pinu)
    const logo = document.querySelector('.site-header__logo');
    const siteHeader = document.querySelector('.site-header');
    if (logo) {
      const getLogoStartY = () =>
        window.innerHeight / 2 - logo.offsetHeight / 2 - logo.getBoundingClientRect().top;
      gsap.fromTo(
        logo,
        { xPercent: -50, x: 0, y: getLogoStartY, scale: 1.1 },
        {
          xPercent: -50,
          x: 0,
          y: 0,
          scale: 1,
          ease: 'power2.inOut',
          scrollTrigger: {
            trigger: starterEl,
            start: 'top top',
            end: '+=80%',
            scrub: true,
            invalidateOnRefresh: true,
            onLeave: () => {
              gsap.set(logo, { pointerEvents: 'auto' });
              siteHeader && siteHeader.classList.add('header--menu-visible');
            },
            onEnterBack: () => {
              gsap.set(logo, { pointerEvents: 'none' });
              siteHeader && siteHeader.classList.remove('header--menu-visible');
            },
          },
        },
      );
    }
  });

  // Anchor scrolling — po inicjalizacji wszystkich ScrollTriggerów
  initAnchorScrolling();
});
